import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored reference number object.
 */
export const storedReferenceNumberSchema: SchemaDefinition = {
	Name: 'stored-reference-number',
	Properties: {
		Number: { Type: 'string' },
		Type: { Type: 'string' }
	}
}